import React from 'react';
import useInView from '../hooks/useInView';

export default function FadeIn({ children, delay = 0, style = {} }) {
  const [ref, v] = useInView();
  return (
    <div ref={ref} style={{ opacity:v?1:0, transform:v?"translateY(0)":"translateY(10px)", transition:`opacity 0.3s ease ${delay}s, transform 0.3s ease ${delay}s`, ...style }}>
      {children}
    </div>
  );
}

